import type React from 'react';

import { useEffect } from 'react';

import { KEYCLOAK_REDIRECT_URL } from '@/model/routes.consts.ts';

export const LogoutController: React.FC = () => {
  const pathname = window.location.pathname;

  useEffect(() => {
    if (pathname === '/logout') {
      window.location.href = KEYCLOAK_REDIRECT_URL;
    }
  }, [pathname]);

  return null;
};
